import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Image,
  Link,
  Stack,
  Text,
  useTheme,
  useToast
} from '@homebotapp/hb-react-component-catalog'
import { useEffect, useMemo, useState, useRef, useCallback } from 'react'
import { AppLayout } from '../../App/Layout/AppLayout'
import { useDispatch, useSelector } from 'react-redux'
import { setActiveNavigationTab } from '../../store/slices/navigation'
import { NAVIGATION_TAB_NAMES } from '../../types/navigation'
import { ListingGalleryTile } from '../../Components/homeSearch/ListingGalleryTile/ListingGalleryTile'
import openDoor from '../../assets/homes/img/openDoor.svg'
import recentPriceDrop from '../../assets/homes/img/priceDrop.svg'
import recentlySold from '../../assets/homes/img/recentlySold.svg'
import { defineMessages, useIntl } from 'react-intl'
import history from '../../history'
import { GoogleAutoComplete } from '../../Components/homeSearch/GoogleAutoComplete/GoogleAutoComplete'
import { CurrentSelectedLocation } from '../../Components/homeSearch/GoogleAutoComplete/state/currentSelectedLocation'
import { PlaceDetailsCompat } from '../../hooks'
import {
  ClientEventName,
  ClientEventSource,
  CreateMarketInterestMutation,
  FeedBase,
  FeedType,
  GeoArea,
  GeoAreaLevel,
  MarketSource
} from '../../api/gqlaxy/gql/generated/graphql'
import { Feed } from '../../Components/homeSearch/Feed/Feed'
import { RootState } from '../../types/rootState'
import { selectHomebotListingsFeatureEnabled, selectNativeAccessFeature } from '../../store/selectors/customerProfile'
import useViewport from '../../hooks/useViewport'
import { DownloadMobileAppPromptCard } from '../../Components/homeSearch/ListingDetails/DownloadMobileAppPromptCard/Desktop/DownloadMobileAppPromptCard'
import { MobileDownloadMobileAppPromptCard } from '../../Components/homeSearch/ListingDetails/DownloadMobileAppPromptCard/Mobile/MobileDownloadMobileAppPromptCard'
import { HomeSearchFooter } from '../../Components/homeSearch/HomeSearchFooter/HomeSearchFooter'
import {
  selectAnswerDate,
  selectAnswerGoal,
  selectClientEmailSettingsOptInRequired,
  selectClientHomes,
  selectClientIsBuyer,
  selectClientIsLoadingData
} from '../../store/selectors/client'
import { useTrackingContext } from '../../providers/tracking'
import { hasCustomerToken, isAuthTokenSupported } from '../../auth'
import { fetchProfile } from '../../actions/customerProfile'
import {
  fetchClientData,
  fetchClientHomes,
  setCurrentClient,
  setClientEmailSettingsOptedInAt
} from '../../actions/client'
import { NoPreviewModeModal } from '../../Components/NoPreviewModeModal/NoPreviewModeModal'
import { fetchBuyerInfoData } from '../../actions'
import { selectAffordability } from '../../store/selectors/buyerInfo'
import { fetchMarketRecordsDetail } from '../../actions/marketRecords'
import { useLocation } from 'react-router'
import { PATH_HELPERS, SEARCH_PATH_HELPERS } from '../../constants/navigation'
import { useCreateClientEvent, useEffectOncePerSessionConditionally } from '../../hooks'
import { useCreateClientEventOnView } from '../../hooks/useCreateClientEventOnView'
import { useGetClientId } from '../../hooks/useGetClientId'
import { INITIALIZE_ROUTE, selectMarketExploreRoute } from '../../store/selectors/routes'
import { camelizeKeys } from '../../helpers/utils'
import qs from 'qs'
import { PrequalConfirmationModal } from '../../Components/shared/PrequalConfirmationModal/PrequalConfirmationModal'
import { selectClientShouldSeeMarketsAndBuyerNavButtons } from '../../store/selectors/navigation'
import { useOpeningVideo } from '../../hooks/useOpeningVideo'
import { BombBomb } from '../../App/BombBomb/BombBomb'
import OpeningVideo from '../../Components/shared/OpeningVideo/OpeningVideo'
import { selectBombBombIsEnabled } from '../../store/slices/bombBomb'
import { BudgetModal } from './components/BudgetModal'
import { MarketSwitchDropdown } from './components/MarketSwitchDropdown'
import { useGetFeedsMarket } from '../../hooks/gallery/useGetFeedsMarket'
import { selectMarket, selectMarketMetadata } from '../../store/selectors/marketRecord'
import { Link as ReactRouterLink } from 'react-router-dom'
import { LinkPill } from './components/LinkPill'
import { WhereAreYouHouseHunting } from './components/WhereAreYouHouseHunting'
import SearchProfileOnboardingCompletionCard from './components/SearchProfileOnboardingCompletionCard'
import { BuyerOnboardingWizardV2 } from '../../Components/buyers/BuyerOnboardingWizard/components/BuyerOnboardingWizardV2'
import { useCreateMarketInterest } from '../../hooks/gallery/useCreateMarketInterest'
import { useGetMarketInterest } from '../../hooks/gallery/useGetMarketInterest'
import { selectBuyerWelcomeVideoId, selectBuyerWelcomeVideoType } from '../../store/selectors/videos'
import BuyerWelcomeVideoModal from '../../Components/buyers/BuyerOnboardingWizard/components/BuyerWelcomeVideoModal'
import {
  getSearchProfileOnboardingShownCount,
  hasWelcomeVideoModalBeenShown,
  markWelcomeVideoModalAsShown
} from '../../helpers/forYouCookieStore'
import { MarketTemperatureIndicatorV2 } from './components/MarketTemperatureIndicatorV2'
import { OwnAHome } from '../../Components/homeSearch/ListingDetails/OwnAHome/OwnAHome'
import { ImpersonationPage } from './components/ImpersonationPage'
import { NoFeedTypeModal } from './components/NoFeedTypeModal'
import { extractGQLErrorMessage } from '../../api/util/errors'
import camelize from 'lodash/camelCase'
import { enableHBB } from '../../api/mikasa/requests'

interface Tile {
  icon: JSX.Element
  label: string
  type?: string
  onClick?: () => void
}

export const MSG = defineMessages({
  exploreMarkets: {
    id: 'Gallery.exploreMarkets',
    defaultMessage: 'Explore your market'
  },
  successMessage: {
    id: 'BuyerOnboardingWizard.successMessage',
    defaultMessage: 'Search profile is 100% complete'
  },
  enterZipCode: {
    id: 'Gallery.enterZipCode',
    defaultMessage: 'Enter a ZIP code'
  },
  galleriesInZip: {
    id: 'Gallery.galleriesInZip',
    defaultMessage: 'Galleries in {zipcode}'
  },
  for: {
    id: 'Gallery.for',
    defaultMessage: 'For'
  },
  concessions: {
    id: 'Gallery.concessions',
    defaultMessage: 'Seller Concessions'
  },
  concessionsDescription: {
    id: 'ForYouContent.concessionsDescription',
    defaultMessage: 'Homes where the seller is offering incentives'
  },
  recentPriceDrop: {
    id: 'Gallery.priceDrops',
    defaultMessage: 'Price Drops'
  },
  recentPriceDropDescription: {
    id: 'Gallery.recentPriceDropDescription',
    defaultMessage: 'Homes with a reduced asking price'
  },
  assumables: {
    id: 'Gallery.assumableLoans',
    defaultMessage: 'Assumable Loans'
  },
  assumablesDescription: {
    id: 'Gallery.assumablesDescription',
    defaultMessage: 'You may be able to take on a low-rate loan!'
  },
  openHouses: {
    id: 'Gallery.openHouses',
    defaultMessage: 'Open Houses'
  },
  openHousesDescription: {
    id: 'Gallery.openHousesDescription',
    defaultMessage: 'See homes in person'
  },
  savedSearches: {
    id: 'Gallery.savedSearches',
    defaultMessage: 'Saved Searches'
  },
  favorites: {
    id: 'Gallery.favorites',
    defaultMessage: 'Favorites'
  },
  yourMarkets: {
    id: 'Gallery.yourMarkets',
    defaultMessage: 'Your Markets'
  },
  newlyListed: {
    id: 'Gallery.newlyListed',
    defaultMessage: 'Newly Listed'
  },
  newlyListedDescription: {
    id: 'Gallery.newlyListedDescription',
    defaultMessage: 'Homes that are just hitting the market'
  },
  recentlySold: {
    id: 'Gallery.recentlySold',
    defaultMessage: 'Recently Sold'
  },
  recentlySoldDescription: {
    id: 'ForYouContent.recentlySoldDescription',
    defaultMessage: 'Explore to see what the market is like'
  },
  localGallery: {
    id: 'Gallery.localGallery',
    defaultMessage: 'Local Gallery'
  },
  forYou: {
    id: 'Gallery.forYou',
    defaultMessage: 'For You'
  },
  help: {
    id: 'ForYouContent.help',
    defaultMessage: "Let's find your next home"
  },
  localGalleries: {
    id: 'Gallery.localGalleries',
    defaultMessage: 'Local Galleries'
  },
  changeLocation: {
    id: 'Gallery.changeLocation',
    defaultMessage: 'Change Location'
  },
  failedChangeLocation: {
    id: 'Gallery.failedChangeLocation',
    defaultMessage: 'Failed to change feed location'
  },
  errorCreatingFeeds: {
    id: 'Gallery.errorCreatingFeeds',
    defaultMessage: 'Error creating feeds'
  },
  searchAllHomesInZip: {
    id: 'Gallery.searchAllHomesInZip',
    defaultMessage: 'Search all homes in {zipcode}'
  },
  zipCodeCantBeAdded: {
    id: 'Gallery.zipCodeCantBeAdded',
    defaultMessage: 'This ZIP code cannot be added to your favorites at this time.'
  },
  zipCodeAlreadyAddedToFavorites: {
    id: 'Gallery.zipCodeAlreadyAddedToFavorites',
    defaultMessage: 'Zipcode is already added to your favorites.'
  },
  acceptInviteToastTitle: {
    id: 'ForYouContent.acceptInviteToast.title',
    defaultMessage: 'You are all set!'
  },
  acceptInviteToastDescription: {
    id: 'ForYouContent.acceptInviteToast.description',
    defaultMessage: "You'll start getting content to help you discover homes that fit your needs and preferences."
  },
  loadingYourMarkets: {
    id: 'ForYouContent.loadingYourMarkets',
    defaultMessage: 'Loading your markets'
  }
})

export interface CurrentlySelectedZipCityState {
  zipcode: string
  city: string
  stateAbbreviation: string
}

export const formatCityName = (city: string | undefined): string => {
  if (!city) return ''
  return city
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

let refreshInterval: NodeJS.Timer | null = null

export const ForYouContent = ({ match }) => {
  const queryParams = camelizeKeys(
    qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    })
  )
  const { search } = useLocation()
  const urlParams = new URLSearchParams(search)
  const queryParamFeedType = urlParams.get('feed_type')
  const queryParamZipCode = urlParams.get('zip_code')

  const intl = useIntl()
  const toast = useToast()
  const { theme } = useTheme()
  const dispatch = useDispatch()
  const { isMediumOrAbove, isSmall } = useViewport()
  const isImpersonating = hasCustomerToken()
  const { customerProfileId } = match.params
  const { trackingClient } = useTrackingContext()
  const clientId = useGetClientId()
  const { mutateAsync: createMarketInterest, isLoading: creatingMarketInterest } = useCreateMarketInterest()
  const [showGooglePlaceSelector, setShowGooglePlaceSelector] = useState(false)
  const [showNoFeedTypeModal, setShowNoFeedTypeModal] = useState(false)
  const hasNativeAccess = useSelector<RootState, boolean>(selectNativeAccessFeature)
  const marketsRoute = useSelector(selectMarketExploreRoute)
  const isBuyer = useSelector(selectClientIsBuyer)
  const emailSettingsOptInRequired = useSelector(selectClientEmailSettingsOptInRequired)
  const isLoadingClientData = useSelector(selectClientIsLoadingData)
  const searchEnabled = useSelector(selectHomebotListingsFeatureEnabled)

  const homes = useSelector(selectClientHomes) || []

  const [dismissedOwnAHome, setDismissedOwnAHome] = useState(localStorage?.getItem('dismissedOwnAHome') === 'true')
  const [hasRedirectedToFeedType, setHasRedirectedToFeedType] = useState(false)
  const [hasShownAcceptInviteToast, setHasShownAcceptInviteToast] = useState(false)

  useEffectOncePerSessionConditionally(
    () => {
      enableHBB(clientId, {}).then(() => {
        dispatch(fetchBuyerInfoData(clientId))
        dispatch(fetchClientData(clientId))
        refetchMarketsInterest()
      })
    },
    undefined,
    !!clientId && !isBuyer
  )

  useEffect(() => {
    const handleStorageChange = () => {
      setDismissedOwnAHome(localStorage?.getItem('dismissedOwnAHome') === 'true')
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [])

  const [showPrequalModal, setShowPrequalModal] = useState(queryParams.openPrequalModal === 'true')
  const clientCanAccessBuyerAndMarkets = useSelector(selectClientShouldSeeMarketsAndBuyerNavButtons)

  const {
    data: marketsInterest,
    refetch: refetchMarketsInterest,
    isLoading: loadingMarketsInterest,
    isFetching: fetchingMarketsInterest
  } = useGetMarketInterest()

  const allMarkets = useMemo(() => {
    if (marketsInterest?.markets) {
      return marketsInterest.markets.reduce(
        (acc, market) => {
          acc[`${market.geoArea.zipCode}`] = market.geoArea
          return acc
        },
        {} as Record<string, GeoArea>
      )
    }
    return {} as Record<string, GeoArea>
  }, [marketsInterest?.markets])

  const clientZipCodes = useMemo(() => {
    if (marketsInterest?.markets) {
      return marketsInterest.markets
        .filter(item => item.source === MarketSource.MarketInterest)
        .map(market => market.geoArea.zipCode)
    }
    return []
  }, [marketsInterest?.markets])

  const allZipCodes = useMemo(() => {
    if (marketsInterest?.markets) {
      return marketsInterest.markets.map(market => market.geoArea.zipCode)
    }
    return []
  }, [marketsInterest?.markets])

  const hasFavoriteMarkets = clientZipCodes.length > 0
  const [currentlySelectedZipCityState, setCurrentlySelectedZipCityState] = useState<CurrentlySelectedZipCityState>({
    zipcode: queryParamZipCode || '',
    city: '',
    stateAbbreviation: ''
  })

  const selectedZipCodeIsNotPartOfMarketsInterest = useMemo(() => {
    const zipCodes = marketsInterest?.markets?.map(market => market.geoArea.zipCode) || []
    return currentlySelectedZipCityState?.zipcode && !zipCodes.includes(currentlySelectedZipCityState?.zipcode)
  }, [currentlySelectedZipCityState, marketsInterest?.markets])

  useEffect(() => {
    // Only set default zipcode if no query param zipcode is provided
    if (
      (!currentlySelectedZipCityState.zipcode && marketsInterest?.markets?.length && !queryParamZipCode) ||
      (selectedZipCodeIsNotPartOfMarketsInterest && !fetchingMarketsInterest && !queryParamZipCode)
    ) {
      // Prioritize MARKET_INTEREST markets (user's home/favorites) over CUSTOMER_OFFICE markets
      const preferredMarket =
        marketsInterest?.markets?.find(m => m.source === MarketSource.MarketInterest) || marketsInterest?.markets?.[0]
      setCurrentlySelectedZipCityState({
        zipcode: preferredMarket?.geoArea?.zipCode || '',
        city: '',
        stateAbbreviation: preferredMarket?.geoArea?.stateAbbreviation || ''
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    marketsInterest,
    selectedZipCodeIsNotPartOfMarketsInterest,
    fetchingMarketsInterest,
    currentlySelectedZipCityState.zipcode,
    queryParamZipCode
  ])

  const market = useSelector(selectMarket(currentlySelectedZipCityState?.zipcode))

  const marketRecord = useSelector(() => selectMarketMetadata(market))
  const marketTemp = marketRecord?.data?.score

  const welcomeVideoId = useSelector(selectBuyerWelcomeVideoId)
  const welcomeVideoType = useSelector(selectBuyerWelcomeVideoType)
  const [showWelcomeVideoModal, setShowWelcomeVideoModal] = useState(false)

  // search profile completion status
  const buyerGoals = useSelector(selectAnswerGoal)
  const buyerCloseDate = useSelector(selectAnswerDate)
  const buyerPricePoint = useSelector(selectAffordability)
  const buyerHasSetGoals = buyerGoals?.length > 0
  const buyerHasSetCloseDate = !!buyerCloseDate
  const buyerHasSetPricePoint = !!buyerPricePoint

  const [isShowingSearchProfileOnboarding, setIsShowingSearchProfileOnboarding] = useState(false)
  // video
  const bombBombIsEnabled = useSelector(selectBombBombIsEnabled)
  const { displayEmailVideo, videoType: videoSource, videoId, audience: audienceType } = useOpeningVideo()
  const trackedVideosRef = useRef<Set<string>>(new Set())
  const { mutateAsync: createViewedVideoEmailClientEvent } = useCreateClientEvent({ disableErrorPrompts: true })
  const displayOpeningVideo = displayEmailVideo

  useEffect(() => {
    const shouldTrackVideoView = Boolean(
      displayEmailVideo && !isLoadingClientData && !trackedVideosRef.current.has(videoId)
    )

    if (shouldTrackVideoView) {
      createViewedVideoEmailClientEvent({
        clientEventInput: {
          eventName: ClientEventName.ViewedVideoEmail,
          eventSource: ClientEventSource.ForYou, // native backend is setting the eventSource so this gets overridden but source should also be for-you in NBE
          properties: {
            activity_source: 'user',
            audience: audienceType,
            video_id: videoId,
            video_source: videoSource
          }
        }
      })
      trackedVideosRef.current.add(videoId)
    }
  }, [
    displayEmailVideo,
    isLoadingClientData,
    videoId,
    audienceType,
    videoSource,
    dispatch,
    createViewedVideoEmailClientEvent
  ])

  const createViewClientEvent = useCreateClientEventOnView({
    eventName: ClientEventName.View,
    eventSource: ClientEventSource.ForYou
  })
  createViewClientEvent()

  const [showNotAuthorizedModal, setShowNotAuthorizedModal] = useState(!isAuthTokenSupported())
  const hasChangeLocationQs = search.includes('changeLocation')

  useEffect(() => {
    // Only show the modal if both videoId and videoType are present
    setShowWelcomeVideoModal(!!welcomeVideoId && !!welcomeVideoType)
  }, [welcomeVideoId, welcomeVideoType])

  const hasValidZipState = !!currentlySelectedZipCityState.zipcode && !!currentlySelectedZipCityState.stateAbbreviation

  // TODO: Uncomment this once we want to create market interest for query param zipcode
  // useEffectOncePerSessionConditionally(
  //   () => {
  //     if (
  //       queryParamZipCode &&
  //       !marketsInterest?.markets?.find(market => market.geoArea.zipCode === queryParamZipCode)
  //     ) {
  //       createMarketInterest({
  //         input: {
  //           clientId,
  //           zipCode: queryParamZipCode
  //         }
  //       })
  //     }
  //   },
  //   `createMarketInterestQueryParamZipcode-${queryParamZipCode}`,
  //   !!queryParamZipCode && !loadingMarketsInterest && !fetchingMarketsInterest && !!marketsInterest && !!clientId
  // )

  // Extract complex expression to a separate variable for static checking
  const allMarketsCount = Object.keys(allMarkets).length

  useEffect(() => {
    // only run if we don't have values set yet or if markets change
    if (!hasValidZipState) {
      // If query param zipcode is provided, try to use that first
      if (
        queryParamZipCode &&
        !marketsInterest?.markets?.find(market => market.geoArea.zipCode === queryParamZipCode)
      ) {
        const queryMarket = allMarkets[queryParamZipCode]
        if (queryMarket) {
          setCurrentlySelectedZipCityState({
            zipcode: queryParamZipCode,
            city: queryMarket.city || '',
            stateAbbreviation: queryMarket.stateAbbreviation
          })
        }
        // Don't fall back to default market if query param is provided but not found yet
        return
      }

      // Original logic for when no query param is provided
      if (hasFavoriteMarkets) {
        const firstFavMarketZip = clientZipCodes[0]
        const firstFavMarket = firstFavMarketZip && allMarkets[firstFavMarketZip]

        // Make sure we have actual values before setting state
        if (firstFavMarket && firstFavMarket.zipCode && firstFavMarket.stateAbbreviation) {
          setCurrentlySelectedZipCityState({
            zipcode: firstFavMarket.zipCode,
            city: firstFavMarket.city || '',
            stateAbbreviation: firstFavMarket.stateAbbreviation
          })
        }
      } else if (currentlySelectedZipCityState?.zipcode && !queryParamZipCode) {
        const market = allMarkets[currentlySelectedZipCityState.zipcode]
        if (market) {
          setCurrentlySelectedZipCityState({
            zipcode: currentlySelectedZipCityState.zipcode,
            city: market.city || '',
            stateAbbreviation: market.stateAbbreviation
          })
        }
      } else {
        return
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allMarketsCount, currentlySelectedZipCityState, clientZipCodes, market, hasFavoriteMarkets, queryParamZipCode])

  const enableGetMarketFeeds = !!searchEnabled && isAuthTokenSupported() && hasValidZipState

  const {
    data,
    refetch: refreshFeeds,
    isLoading: isLoadingFeeds
  } = useGetFeedsMarket(
    {
      input: {
        clientId,
        geoArea: {
          zipCode: currentlySelectedZipCityState?.zipcode,
          level: GeoAreaLevel.PostalCode,
          name: currentlySelectedZipCityState?.zipcode,
          stateAbbreviation: currentlySelectedZipCityState?.stateAbbreviation
        }
      }
    },
    {
      enabled: enableGetMarketFeeds,
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      disableErrorPrompts: false
    }
  )

  useEffect(() => {
    if (allZipCodes.length > 0) {
      dispatch(fetchMarketRecordsDetail(allZipCodes))
    }
  }, [allZipCodes, dispatch])

  const refreshBuyerInfoStates = () => {
    dispatch(fetchBuyerInfoData(clientId))
    dispatch(fetchClientData(clientId))
  }

  useEffect(() => {
    if (!isAuthTokenSupported()) {
      return setShowNotAuthorizedModal(true)
    }

    refreshBuyerInfoStates()
    if (customerProfileId) {
      dispatch(fetchProfile(customerProfileId))
    }
  }, [dispatch, customerProfileId])

  useEffect(() => {
    if (clientId) {
      dispatch(setCurrentClient(clientId))
      dispatch(fetchClientData(clientId, customerProfileId))
      dispatch(fetchClientHomes(clientId))
    }
  }, [dispatch, clientId, customerProfileId])

  // Handle accept-invite query parameter
  useEffect(() => {
    if (
      clientId &&
      queryParams.acceptInvite === 'true' &&
      emailSettingsOptInRequired === true &&
      !hasShownAcceptInviteToast
    ) {
      setHasShownAcceptInviteToast(true)
      dispatch(setClientEmailSettingsOptedInAt({ setTo: new Date() }))
      toast({
        title: intl.formatMessage(MSG.acceptInviteToastTitle),
        description: intl.formatMessage(MSG.acceptInviteToastDescription),
        status: 'success'
      })
    }
  }, [emailSettingsOptInRequired, clientId, queryParams.acceptInvite, dispatch, toast, intl, hasShownAcceptInviteToast])

  // Handle automatic redirection to feed type when specified in query params
  useEffect(() => {
    if (queryParamFeedType && data?.feedsMarket?.length > 0 && !isLoadingFeeds && !hasRedirectedToFeedType) {
      const targetFeed = data.feedsMarket.find(feed => feed?.feedType === camelize(queryParamFeedType))

      if (targetFeed && targetFeed.id) {
        setHasRedirectedToFeedType(true)

        trackingClient?.linkInteraction({
          ui_context: 'Gallery_Feed',
          descriptor: `Auto-navigated to Feed ${targetFeed.feedType}`,
          action: 'Auto-Navigate',
          guid: `3GtcZMbe9HLD7YUKKiAyjg_auto_${targetFeed.feedType}`
        })

        history.push(
          SEARCH_PATH_HELPERS.gallery.buildPath(customerProfileId, targetFeed.id, targetFeed.feedType, clientId)
        )
      }
    }

    if (queryParamFeedType && data?.feedsMarket.length === 0 && !isLoadingFeeds && !hasRedirectedToFeedType) {
      setShowNoFeedTypeModal(true)
    }
  }, [
    queryParamFeedType,
    data?.feedsMarket,
    hasRedirectedToFeedType,
    customerProfileId,
    clientId,
    trackingClient,
    isLoadingFeeds
  ])

  useEffect(() => {
    dispatch(setActiveNavigationTab(NAVIGATION_TAB_NAMES.FORYOU))
  }, [dispatch])

  // Refresh feeds when the selected location changes
  useEffect(() => {
    if (enableGetMarketFeeds) {
      refreshFeeds()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enableGetMarketFeeds])

  const onShowGooglePlaceSelector = () => {
    if (isImpersonating) {
      toast({
        description: 'Changing gallery locations on behalf of your clients is not supported at this time.',
        status: 'warning'
      })
    } else {
      setShowGooglePlaceSelector(true)
    }
  }

  useEffectOncePerSessionConditionally(
    () => {
      onShowGooglePlaceSelector()
      history.push({ search: '' })
    },
    undefined,
    hasChangeLocationQs
  )

  // empty state - no zip or market data
  useEffect(() => {
    if (
      !queryParamZipCode &&
      !marketsInterest?.markets?.length &&
      !data?.feedsMarket?.length &&
      !isLoadingFeeds &&
      !showWelcomeVideoModal &&
      !isLoadingClientData &&
      !loadingMarketsInterest
    ) {
      setShowGooglePlaceSelector(true)
    } else {
      setShowGooglePlaceSelector(false)
    }
  }, [
    queryParamZipCode,
    marketsInterest?.markets?.length,
    data?.feedsMarket?.length,
    isLoadingFeeds,
    showWelcomeVideoModal,
    isLoadingClientData,
    loadingMarketsInterest
  ])

  const onAddMarket = async (zipCode: string): Promise<CreateMarketInterestMutation> => {
    const createdMarketInterest = await createMarketInterest({
      input: {
        clientId,
        zipCode
      }
    })
    return createdMarketInterest
  }

  const onLocationAdded = async (place: CurrentSelectedLocation, placeDetails?: PlaceDetailsCompat | null) => {
    try {
      if (!isAuthTokenSupported()) {
        return
      }

      const addressComponents = placeDetails?.address_components

      if (!addressComponents) {
        return
      }

      const zipCode = addressComponents.find(component => component.types.includes('postal_code'))?.long_name
      if (!zipCode) {
        return
      }

      if (clientZipCodes.includes(zipCode)) {
        toast({
          description: intl.formatMessage(MSG.zipCodeAlreadyAddedToFavorites),
          status: 'warning'
        })
        return
      }

      const createdMarketInterest = await onAddMarket(zipCode)

      if (!hasFavoriteMarkets && buyerHasSetGoals && buyerHasSetCloseDate && buyerHasSetPricePoint) {
        toast({
          title: intl.formatMessage(MSG.successMessage),
          status: 'success'
        })
      }

      if (createdMarketInterest.createMarketInterest.id) {
        const stateAbbreviation = addressComponents.find(component =>
          component.types.includes('administrative_area_level_1')
        )?.short_name
        const city = addressComponents.find(component => component.types.includes('locality'))?.long_name

        if (!stateAbbreviation || !city) {
          return
        }
        setCurrentlySelectedZipCityState({
          zipcode: zipCode,
          city,
          stateAbbreviation
        })

        setShowGooglePlaceSelector(false)
        refetchMarketsInterest()
      } else {
        toast({
          description: intl.formatMessage(MSG.zipCodeCantBeAdded),
          status: 'warning',
          duration: 4000,
          position: 'top'
        })
      }
    } catch (err) {
      const errorCode = err instanceof Error ? extractGQLErrorMessage(err) : 'Unknown error'
      if (errorCode === 'createMarketInterest-zipCodeAlreadyExists') {
        toast({
          description: intl.formatMessage(MSG.zipCodeAlreadyAddedToFavorites),
          status: 'warning'
        })
        return
      }
      toast({
        description: intl.formatMessage(MSG.failedChangeLocation),
        status: 'error'
      })
    }
  }

  const onLocationChange = (zipCityState: CurrentlySelectedZipCityState) => {
    setCurrentlySelectedZipCityState(zipCityState)
  }

  const removeDuplicateRecentlySoldFeeds = (feeds: FeedBase[]) => {
    const firstRecentlySoldIndex = feeds.findIndex(feed => feed.feedType === 'recentlySold')
    if (firstRecentlySoldIndex === -1) return
    const secondRecentlySoldIndex = feeds.findIndex(
      (feed, i) =>
        feed.feedType === 'recentlySold' &&
        i !== firstRecentlySoldIndex &&
        feed.location?.zipCode === feeds[firstRecentlySoldIndex].location?.zipCode
    )
    if (secondRecentlySoldIndex !== -1) {
      feeds.splice(secondRecentlySoldIndex, 1)
    }
  }

  useEffect(() => {
    if (data?.feedsMarket) {
      removeDuplicateRecentlySoldFeeds(data.feedsMarket)
    }
  }, [data?.feedsMarket])

  // this logic was copied from the MarketsTab component
  const buildMarketsRoute = useCallback(() => {
    if (hasCustomerToken()) {
      const impersonatedClientId: string = localStorage?.getItem('impersonatedClientId') || ''
      const impersonatedClientIsBuyer: boolean = localStorage?.getItem('impersonatedClientHbbAccess') === 'true'

      const buyRoute =
        impersonatedClientIsBuyer && !!impersonatedClientId
          ? PATH_HELPERS.markets.buildPath(impersonatedClientId, '/explore/map')
          : INITIALIZE_ROUTE
      return buyRoute
    } else {
      return marketsRoute
    }
  }, [marketsRoute])

  const linkPills = useMemo(() => {
    return (
      <Stack direction='row' spacing={2} overflowX='auto' flexWrap='nowrap'>
        <Flex flex='0 0 auto' direction='column'>
          <Stack direction='row' spacing={2}>
            {searchEnabled && (
              <LinkPill
                iconName='bookmark-magnifying-glass'
                label={isSmall ? undefined : intl.formatMessage(MSG.savedSearches)}
                to={SEARCH_PATH_HELPERS.savedSearches.buildPath(customerProfileId, clientId)}
                tracking={{
                  ui_context: 'Gallery_SavedSearch_Link',
                  descriptor: 'Clicked on Saved Search',
                  guid: '3GtpqMPqaHLD7YUKKiAyjg'
                }}
              />
            )}
            {searchEnabled && (
              <LinkPill
                iconName='heart'
                label={isSmall ? undefined : intl.formatMessage(MSG.favorites)}
                to={SEARCH_PATH_HELPERS.favoriteListings.buildPath(customerProfileId, clientId)}
                tracking={{
                  ui_context: 'Gallery_Favorites_Link',
                  descriptor: 'Clicked on Favorites',
                  guid: '3GtcZMPqaHLD7YUKKiAyjg'
                }}
              />
            )}
            {clientCanAccessBuyerAndMarkets && (
              <LinkPill
                iconName='map-marked-alt-filled'
                label={isSmall ? undefined : intl.formatMessage(MSG.yourMarkets)}
                to={buildMarketsRoute()}
                tracking={{
                  ui_context: 'Gallery_YourMarkets_Link',
                  descriptor: 'Clicked on Your Markets',
                  guid: '7mbCiLVFgWFgKreJzezdPa'
                }}
              />
            )}
          </Stack>
        </Flex>
      </Stack>
    )
  }, [intl, isSmall, searchEnabled, clientCanAccessBuyerAndMarkets, customerProfileId, clientId, buildMarketsRoute])

  const headerTitle = useMemo(() => {
    const selectedMarket = allMarkets[currentlySelectedZipCityState?.zipcode]
    if (selectedMarket) {
      return selectedMarket.name?.replace(/,/g, ' -')
    }
    return `${currentlySelectedZipCityState?.zipcode} - ${formatCityName(currentlySelectedZipCityState?.city)}`
  }, [allMarkets, currentlySelectedZipCityState])

  const hasSubscribedToAnyFeed = data?.feedsMarket?.some(feed => feed?.subscribed === true)

  useEffect(() => {
    if (currentlySelectedZipCityState?.zipcode) {
      refreshFeeds()
    }
  }, [currentlySelectedZipCityState])

  if (isImpersonating && !hasSubscribedToAnyFeed) {
    return <ImpersonationPage match={match} />
  }

  return (
    <AppLayout
      loadingMessage={intl.formatMessage(MSG.loadingYourMarkets)}
      loading={
        !showNoFeedTypeModal &&
        (isLoadingClientData ||
          loadingMarketsInterest ||
          (queryParamZipCode && selectedZipCodeIsNotPartOfMarketsInterest && isLoadingFeeds) ||
          (data?.feedsMarket?.length === undefined && isLoadingFeeds))
      }
      enableAgentDropdown
      match={match}
    >
      {showPrequalModal && (
        <PrequalConfirmationModal onClose={() => setShowPrequalModal(false)} uiContext='For You Page' eventSource='for-you' />
      )}

      {showNotAuthorizedModal && <NoPreviewModeModal />}
      <NoFeedTypeModal
        isOpen={showNoFeedTypeModal}
        onClose={() => setShowNoFeedTypeModal(false)}
        onMarketAdded={() => {
          setShowNoFeedTypeModal(false)
          refreshFeeds()
        }}
        market={queryParamZipCode || currentlySelectedZipCityState?.zipcode}
      />
      {showGooglePlaceSelector && (
        <GoogleAutoComplete
          placeholder={intl.formatMessage(MSG.enterZipCode)}
          types={['postal_code', 'administrative_area_level_1']}
          onClose={() => setShowGooglePlaceSelector(false)}
          onPlaceSelected={onLocationAdded}
          returnPlaceDetails={true}
        />
      )}
      {bombBombIsEnabled && (
        <Box position='absolute' top='10px' right='10px' zIndex='ceiling'>
          <BombBomb />
        </Box>
      )}
      {displayOpeningVideo && (
        <Box mb='2'>
          <OpeningVideo />
        </Box>
      )}
      <Box
        mt={-2}
        pt={8}
        pb={12}
        px={[5, null, null, null, 20]}
        backgroundSize='cover'
        backgroundBlendMode='multiply'
        backgroundColor='whiteAlpha.50'
        _dark={{
          backgroundColor: 'blackAlpha.600'
        }}
      >
        <Flex flexDirection={['column', 'column', 'row']} gap={[2, 4]} justifyContent={'space-between'} flexWrap='wrap'>
          <Box>
            <Flex pb={4} alignItems='center' justifyContent='space-between'>
              <Box width='100%'>
                <Flex flex={1} alignItems='center' justifyContent='space-between' mb={4}>
                  <Heading as='h1' size='2xl' textAlign='left' m={0} fontWeight={600}>
                    {intl.formatMessage(MSG.forYou)}
                  </Heading>
                  {isSmall && linkPills}
                </Flex>
                <Text m={0} size='xs' color='neutral.900'>
                  {intl.formatMessage(MSG.help)}
                </Text>
              </Box>
            </Flex>
            {!isSmall && linkPills}
          </Box>
          <Box mt={4} alignSelf={['center', 'center', 'flex-end']} w={['100%', '100%', 'auto']}>
            <BudgetModal />
          </Box>
        </Flex>
      </Box>

      <Box
        // @ts-ignore
        background='linear-gradient(0.25turn, var(--hb-colors-primary-500), var(--hb-colors-text-brand))'
        h='0.0625rem'
        w='100%'
        data-qa='for-you-divider'
      />

      <Box px={[5, null, null, null, 20]} mt={8}>
        <>
          {getSearchProfileOnboardingShownCount() >= 3 && (
            <>
              {!hasFavoriteMarkets && !loadingMarketsInterest && (
                <WhereAreYouHouseHunting
                  onPlaceSelected={onLocationAdded}
                  setShowGooglePlaceSelector={setShowGooglePlaceSelector}
                />
              )}

              {!isImpersonating &&
                (!buyerHasSetGoals || !buyerHasSetCloseDate || !buyerHasSetPricePoint || !hasFavoriteMarkets) && (
                  <SearchProfileOnboardingCompletionCard
                    buyerHasSetFavoriteMarkets={hasFavoriteMarkets}
                    buyerHasSetGoals={buyerHasSetGoals}
                    buyerHasSetCloseDate={buyerHasSetCloseDate}
                    buyerHasSetPricePoint={buyerHasSetPricePoint}
                    onOpenFavoriteMarketModal={() => {
                      setShowGooglePlaceSelector(true)
                    }}
                    setIsShowingSearchProfileOnboarding={setIsShowingSearchProfileOnboarding}
                  />
                )}
            </>
          )}
        </>

        {homes.length === 0 &&
          hasFavoriteMarkets &&
          buyerHasSetGoals &&
          buyerHasSetCloseDate &&
          buyerHasSetPricePoint &&
          !dismissedOwnAHome && <OwnAHome enableDismiss={true} onDismiss={() => setDismissedOwnAHome(true)} />}

        <BuyerOnboardingWizardV2
          isShowing={
            !isImpersonating &&
            isShowingSearchProfileOnboarding &&
            (!buyerHasSetGoals || !buyerHasSetCloseDate || !buyerHasSetPricePoint)
          }
          setIsShowing={setIsShowingSearchProfileOnboarding}
          buyerHasSetGoals={buyerHasSetGoals}
          buyerHasSetCloseDate={buyerHasSetCloseDate}
          buyerHasSetPricePoint={buyerHasSetPricePoint}
          hasFavoriteMarkets={hasFavoriteMarkets}
        />

        {!isImpersonating && showWelcomeVideoModal && !hasWelcomeVideoModalBeenShown() && (
          <BuyerWelcomeVideoModal
            handleSubmitClick={() => {
              setShowWelcomeVideoModal(false)
              markWelcomeVideoModalAsShown()
              refreshBuyerInfoStates()
            }}
          />
        )}
        {(hasFavoriteMarkets || currentlySelectedZipCityState?.zipcode) && !isImpersonating && (
          <Flex justifyContent='space-between' alignItems='center' mb={8} flexDirection={['column', 'column', 'row']}>
            <Heading as='h2' size='xl' textAlign='left' m={0} fontWeight={600} mb={4}>
              {intl.formatMessage(MSG.exploreMarkets)}
            </Heading>
            <Box width={['100%', '100%', 'auto']}>
              <MarketSwitchDropdown
                selectedZip={currentlySelectedZipCityState?.zipcode}
                setShowGooglePlaceSelector={setShowGooglePlaceSelector}
                onLocationChange={onLocationChange}
              />
            </Box>
          </Flex>
        )}

        {searchEnabled && (
          <>
            {data?.feedsMarket?.map((feed, index) => {
              if (!MSG[feed?.feedType]) {
                return null
              }

              if (index === 2) {
                return (
                  <>
                    {isBuyer && marketTemp && (hasFavoriteMarkets || currentlySelectedZipCityState?.zipcode) && (
                      <MarketTemperatureIndicatorV2
                        zipCode={currentlySelectedZipCityState?.zipcode}
                        onSendMessageComplete={() => {
                          setShowPrequalModal(true)
                        }}
                      />
                    )}
                    <Feed key={feed?.id} feed={feed as FeedBase} />
                  </>
                )
              }

              return <Feed key={feed?.id} feed={feed as FeedBase} />
            })}
          </>
        )}
        {(hasFavoriteMarkets || currentlySelectedZipCityState?.zipcode) && (
          <>
            {isSmall ? (
              <Button
                width='100%'
                as={ReactRouterLink}
                colorScheme='primary'
                to={`${SEARCH_PATH_HELPERS.search.buildPath(
                  customerProfileId
                )}?postal_code=${currentlySelectedZipCityState?.zipcode}&statuses%5B0%5D=Active&statuses%5B1%5D=Coming%20Soon`}
                tracking={{
                  ui_context: 'Gallery_SearchAllHomesInZip_Card',
                  descriptor: 'Clicked on Search All Homes in Zip',
                  guid: '3GtcZMPqaHLD7YUUKiAyjg'
                }}
              >
                <Text mb={0} fontWeight='600'>
                  {intl.formatMessage(MSG.searchAllHomesInZip, {
                    zipcode: currentlySelectedZipCityState?.zipcode
                  })}
                </Text>
                <Icon name='circle-arrow-right-bts' ml={1} />
              </Button>
            ) : (
              <Link
                as={ReactRouterLink}
                to={`${SEARCH_PATH_HELPERS.search.buildPath(
                  customerProfileId
                )}?postal_code=${currentlySelectedZipCityState?.zipcode}&statuses%5B0%5D=Active&statuses%5B1%5D=Coming%20Soon`}
                tracking={{
                  ui_context: 'Gallery_SearchAllHomesInZip_Card',
                  descriptor: 'Clicked on Search All Homes in Zip',
                  guid: '3GtcZMPqaHLD7YUKPwAyjg'
                }}
                display='flex'
                alignItems='center'
                justifyContent='center'
                mb={8}
              >
                <Text mb={0}>
                  {intl.formatMessage(MSG.searchAllHomesInZip, {
                    zipcode: currentlySelectedZipCityState?.zipcode
                  })}
                </Text>
                <Icon name='circle-arrow-right-bts' ml={1} />
              </Link>
            )}
          </>
        )}
      </Box>

      {hasNativeAccess && (
        <Box margin={8}>
          {isMediumOrAbove ? (
            <DownloadMobileAppPromptCard isLandingPage={true} />
          ) : (
            <MobileDownloadMobileAppPromptCard isLandingPage={true} />
          )}
        </Box>
      )}
      <HomeSearchFooter />
    </AppLayout>
  )
}
